import { Route, Routes } from "react-router-dom";
import Automations from "./Automations";

export default function AutomationsRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Automations />} />
    </Routes>
  );
}
